function extractQueryStringFromLocation(location) {
  let locationUrl = '';

  if (typeof location === 'string') {
    locationUrl = location;
  } else if (location.href) {
    locationUrl = location.href;
  } else if (location.hash) {
    locationUrl = location.hash;
  } else {
    locationUrl = '';
  }

  if (locationUrl && locationUrl.indexOf('?') !== -1) {
    locationUrl = locationUrl.substring(locationUrl.indexOf('?'));
  }

  return locationUrl;
}

export function parseQuery(location) {
  const locationUrl = extractQueryStringFromLocation(location);

  const query = {};
  const pairs = (locationUrl[0] === '?' ? locationUrl.substr(1) : locationUrl).split('&');

  for (let i = 0; i < pairs.length; i++) {
    const pair = pairs[i].split('=');
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
  }
  return query;
}
